// extracted by mini-css-extract-plugin
export default {"Header":"hero_Header__m+yGL","title":"hero_title__asHPU","subtext":"hero_subtext__19H+i","hero":"hero_hero__WVt1p"};